import React from 'react';
import { LoginPagesDetails } from '../../libs/login-pages-management/components';
import { Page, PageBody, PageHeader } from '../../libs/shared/page';
import { QlfPageErrorBoundary } from '../../libs/shared/QlfPageErrorBoundary';
import { TopBar } from '../../libs/shared/layout/TopBar';

export function LoginPageManagementIndexPage() {
  return (
    <Page>
      <PageHeader>
        <TopBar />
      </PageHeader>
      <PageBody>
        <QlfPageErrorBoundary>
          <LoginPagesDetails />
        </QlfPageErrorBoundary>
      </PageBody>
    </Page>
  );
}
